import { useMemo, useState, useCallback, useRef } from 'react';
import AssetEnlarged from './AssetEnlarged';
import { AnimatePresence } from 'motion/react';
import styles from './AssetCarousel.module.css';

export default function AssetCarousel({assets}) {

    const [ enlarged, setEnlarged ] = useState({open: false, src: ''});
    const carouselRef = useRef(null);
    const assetLength = assets.length || 0;

    const handleAssetClick = useCallback((asset) => {
        if (asset?.fileType === 'image') {
            setEnlarged({open: true, src: asset.url})
        }
    },[]);

    const handleCloseEnlarged = () => {
        setEnlarged({open: false, src: ''})
    };

    const scrollCarousel = (direction) => {
        if (carouselRef.current) {
            const assetWidth = carouselRef.current.querySelector(`.${styles.asset}`).offsetWidth + 16;
            const scrollDistance = direction === 'next' ? assetWidth : -assetWidth;

            carouselRef.current.scrollBy({
                left: scrollDistance,
                behavior: 'smooth',
            });
        }
    };

    return (
        <>
        <div className={styles.carouselContainer}>
            <div className={styles.carousel} ref={carouselRef}>
                {assetLength > 0 ? (
                    assets.map((asset, index) => (
                        <div key={index} className={styles.asset}>
                            <AssetContent asset={asset} handleAssetClick={handleAssetClick} />
                        </div>
                    ))
                ) : (
                    <div className={styles.noAssets}>There are no files associated with this QR.</div>
                )}
                <button className={styles.swipeBtn} onClick={() => scrollCarousel('prev')} disabled={assetLength <= 3}><i className='far fa-chevron-left' /></button>
                <button className={styles.swipeBtn} onClick={() => scrollCarousel('next')}  disabled={assetLength <= 3}><i className='far fa-chevron-right' /></button>
            </div>
        </div>
        <AnimatePresence initial={false}>
            {enlarged.open && <AssetEnlarged src={enlarged.src} onClose={handleCloseEnlarged} />}
        </AnimatePresence>
        </>
    );
};

const AssetContent = ({asset, handleAssetClick}) => {
    const handleAssetReturn = useMemo(() => {
        if (asset?.fileType === 'image') {
            return (
                <div className={styles.imgWrap} onClick={() => handleAssetClick(asset)}>
                    <img src={asset?.url} className={styles.img} alt={`Asset file`} />
                </div>
            );
        } else if (asset?.fileType === 'pdf') {
            return (
                <div className={styles.pdfWrap}>
                    <i className='far fa-file-pdf' />
                    <a href={asset?.url} className={styles.pdfBtn} download={`${asset?.path.split('/')[1]}`} target='_blank'>Download</a>
                </div>
            );
        }
        return null;
    },[asset, handleAssetClick]);

    return <>{handleAssetReturn}</>
};